import request from 'axios'
import axios from 'axios'
import Store from '../store'
import moment from 'moment'
import _ from 'lodash'

const GLOB = {}
GLOB.maxExtent = 88 // from-to has 3 months limit, DB optimization - in days
export function authenticate() {
  return new Promise((resolve, reject) => {
    const {authenticationUrls, environment, token, oktAppGUID, instance, areaid} = Store.current;
    var url = authenticationUrls[environment.toLowerCase()] + `${authenticationUrls.oAuthService}`;
    var json = {
      "DatosClienteIN": {
        "AppGUID": oktAppGUID,
        "Properties": [
          {
            "Id": "SentinelInstanceId",
            "Value": instance
          },
          {
            "Id": "AreaId",
            "Value": areaid
          }
        ]
      }
    };

// resolve({
//     "EstadoWS": {
//         "Exitoso": true,
//         "Mensaje": ""
//     },
//     "ValidoMapaAppCultivosOUT": {
//         "CampoNombre": "Bañados de Carrasco",
//         "FechaDesde": "2017-05-01",
//         "DechaHasta": "2017-08-30",
//         "VisualizaTodoElMapa": true,
//         "Poligonos": [
//             {
//                 "Html": "<table><tr style=\"color:#0000FF;font-weight:bold;\">\t<td>Campo:</td>\t<td>Bañados de Carrasco</td></tr><tr style=\"color:#0000FF;\">\t<td>Superficie (has):</td>\t<td>391.80</td></tr><tr style=\"color:#DE8C18;font-weight:bold;\">\t<td>Lote/Potrero:</td>\t<td>L1</td></tr><tr style=\"color:#008000;font-weight:bold;\">\t<td>Cultivo:</td>\t<td>Soja</td></tr>\t<td>Tipo de Cultivo:</td>\t<td></td></tr><tr>\t<td>Híbrido/Variedad:</td>\t<td></td></tr><tr>\t<td>Sembrado el:</td>\t<td>01/06/17</td></tr><tr>\t<td>Superficie (has):</td>\t<td>168.80</td></tr></table>",
//                 "Opacidad": false,
//                 "Shape": [
//                     {
//                         "Id": "sie;1023;1;55d7ad17-e5fd-454a-b440-5b63b639205d",
//                         "Type": "polygon",
//                         "Center": {
//                             "Lat": "0.000000000000",
//                             "Lng": "0.000000000000"
//                         },
//                         "Radius": "0",
//                         "NorthEast": {
//                             "Lat": "0.000000000000",
//                             "Lng": "0.000000000000"
//                         },
//                         "SouthWest": {
//                             "Lat": "0.000000000000",
//                             "Lng": "0.000000000000"
//                         },
//                         "Readonly": false,
//                         "FillCssColor": "transparent",
//                         "FillOpacity": 0,
//                         "StrokeWeight": 2,
//                         "StrokeColor": "#008000",
//                         "Path": [
//                             {
//                                 "Lat": "-34.838674765386",
//                                 "Lng": "-56.082415580749"
//                             },
//                             {
//                                 "Lat": "-34.843817215390",
//                                 "Lng": "-56.075077056884"
//                             },
//                             {
//                                 "Lat": "-34.846670079905",
//                                 "Lng": "-56.074433326721"
//                             },
//                             {
//                                 "Lat": "-34.849029781994",
//                                 "Lng": "-56.073145866394"
//                             },
//                             {
//                                 "Lat": "-34.850156780011",
//                                 "Lng": "-56.073017120361"
//                             },
//                             {
//                                 "Lat": "-34.850790709612",
//                                 "Lng": "-56.073875427246"
//                             },
//                             {
//                                 "Lat": "-34.850508963725",
//                                 "Lng": "-56.074304580688"
//                             },
//                             {
//                                 "Lat": "-34.850896364071",
//                                 "Lng": "-56.074819564819"
//                             },
//                             {
//                                 "Lat": "-34.851635941483",
//                                 "Lng": "-56.074218750000"
//                             },
//                             {
//                                 "Lat": "-34.852340294742",
//                                 "Lng": "-56.075077056884"
//                             },
//                             {
//                                 "Lat": "-34.853044641972",
//                                 "Lng": "-56.075034141540"
//                             },
//                             {
//                                 "Lat": "-34.853854633833",
//                                 "Lng": "-56.075849533081"
//                             },
//                             {
//                                 "Lat": "-34.853748983173",
//                                 "Lng": "-56.077566146850"
//                             },
//                             {
//                                 "Lat": "-34.853185510695",
//                                 "Lng": "-56.078639030456"
//                             },
//                             {
//                                 "Lat": "-34.853255944966",
//                                 "Lng": "-56.080183982849"
//                             },
//                             {
//                                 "Lat": "-34.854594184654",
//                                 "Lng": "-56.078553199768"
//                             },
//                             {
//                                 "Lat": "-34.855192863782",
//                                 "Lng": "-56.078081130981"
//                             },
//                             {
//                                 "Lat": "-34.855791538555",
//                                 "Lng": "-56.078252792358"
//                             },
//                             {
//                                 "Lat": "-34.855932402574",
//                                 "Lng": "-56.078724861145"
//                             },
//                             {
//                                 "Lat": "-34.854911132970",
//                                 "Lng": "-56.079840660095"
//                             },
//                             {
//                                 "Lat": "-34.855474593630",
//                                 "Lng": "-56.080870628356"
//                             },
//                             {
//                                 "Lat": "-34.854981565764",
//                                 "Lng": "-56.081471443176"
//                             },
//                             {
//                                 "Lat": "-34.855545025941",
//                                 "Lng": "-56.082115173339"
//                             },
//                             {
//                                 "Lat": "-34.850403308769",
//                                 "Lng": "-56.088123321533"
//                             },
//                             {
//                                 "Lat": "-34.849452408059",
//                                 "Lng": "-56.087093353271"
//                             },
//                             {
//                                 "Lat": "-34.847761890775",
//                                 "Lng": "-56.088809967041"
//                             },
//                             {
//                                 "Lat": "-34.846987058747",
//                                 "Lng": "-56.089496612548"
//                             },
//                             {
//                                 "Lat": "-34.847022278543",
//                                 "Lng": "-56.090869903564"
//                             },
//                             {
//                                 "Lat": "-34.846670079905",
//                                 "Lng": "-56.091427803039"
//                             },
//                             {
//                                 "Lat": "-34.842161804221",
//                                 "Lng": "-56.083745956420"
//                             }
//                         ]
//                     }
//                 ]
//             },
//             {
//                 "Html": "<table><tr style=\"color:#0000FF;font-weight:bold;\">\t<td>Campo:</td>\t<td>Bañados de Carrasco</td></tr><tr style=\"color:#0000FF;\">\t<td>Superficie (has):</td>\t<td>391.80</td></tr><tr style=\"color:#DE8C18;font-weight:bold;\">\t<td>Lote/Potrero:</td>\t<td>L1</td></tr><tr style=\"color:#DE8C18;font-weight:bold;\">\t<td>Superficie (has):</td>\t<td>208.84</td></tr></table>",
//                 "Opacidad": true,
//                 "Shape": [
//                     {
//                         "Id": "lte;1023;1",
//                         "Type": "polygon",
//                         "Center": {
//                             "Lat": "0.000000000000",
//                             "Lng": "0.000000000000"
//                         },
//                         "Radius": "0",
//                         "NorthEast": {
//                             "Lat": "0.000000000000",
//                             "Lng": "0.000000000000"
//                         },
//                         "SouthWest": {
//                             "Lat": "0.000000000000",
//                             "Lng": "0.000000000000"
//                         },
//                         "Readonly": false,
//                         "FillCssColor": "transparent",
//                         "FillOpacity": 0,
//                         "StrokeWeight": 2,
//                         "StrokeColor": "#DE8C18",
//                         "Path": [
//                             {
//                                 "Lat": "-34.857481890865",
//                                 "Lng": "-56.079368591308"
//                             },
//                             {
//                                 "Lat": "-34.854101151512",
//                                 "Lng": "-56.073875427246"
//                             },
//                             {
//                                 "Lat": "-34.850297653678",
//                                 "Lng": "-56.073274612426"
//                             },
//                             {
//                                 "Lat": "-34.850438527103",
//                                 "Lng": "-56.071815490722"
//                             },
//                             {
//                                 "Lat": "-34.847268816692",
//                                 "Lng": "-56.068983078002"
//                             },
//                             {
//                                 "Lat": "-34.846282659663",
//                                 "Lng": "-56.071643829345"
//                             },
//                             {
//                                 "Lat": "-34.838604318635",
//                                 "Lng": "-56.081943511962"
//                             },
//                             {
//                                 "Lat": "-34.842619687237",
//                                 "Lng": "-56.083917617797"
//                             },
//                             {
//                                 "Lat": "-34.847198377296",
//                                 "Lng": "-56.091985702514"
//                             }
//                         ]
//                     }
//                 ]
//             }
//         ]
//     }
// });
// return;

    request
      .post(url, json, {
        responseType: 'json',
        headers: {
          'GENEXUS-AGENT': 'SmartDevice Application',
          'Content-Type': 'application/json',
          'Authorization': `OAuth ${token}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch(err => reject(err))
  })
}

const dsCache = {}

export function loadGetCapabilities(ds = null, firstLoad = false) {
  const { datasources, preset, dateFormat } = Store.current
  const { url, minDate, maxDate = moment(), id: datasetId } = ds
  const existing = dsCache[datasetId]
  if (existing) {
    const { channels, presets, preset } = existing
    Store.setChannels(channels)
    if (ds !== null) {
      Store.setPreset(preset)
      Store.setDatasource(ds)
    }
    Store.setPresets(presets)
    return Promise.resolve()
  }
  const capabilitiesUrl = `${url}?SERVICE=WMS&REQUEST=GetCapabilities`
  return new Promise((resolve, reject) => {
    var parseString = require('xml2js').parseString
    request
      .get(`${capabilitiesUrl}&time=${new Date().valueOf()}`, {
        //we add time parameter so caching is prevented
        responseType: 'text'
      })
      .then(res => {
        parseString(res.data, (err, result) => {
          let instanceName = result.WMS_Capabilities.Service[0].Title[0]
          let layers = result.WMS_Capabilities.Capability[0].Layer[0].Layer
          var myRegexp = /^B[0-9][0-9A]/i //excluse "B01", "B8A" etc. layer names
          let preset = null,
            channels = []
          let presets = { ...Store.current.customPreset }
          for (let l in layers) {
            if (layers.hasOwnProperty(l)) {
              var layerName = layers[l].Name[0]
              const splitName = layerName.split('.')[1]
              if (layerName === 'FILL' || splitName === 'FILL') break
              if (!myRegexp.test(layerName)) {
                let desc = layers[l].Abstract ? layers[l].Abstract[0] : ''
                if (!preset) {
                  preset = layerName //set first layer as default selection
                }
                let legendUrl = getLegendUrl(layers[l])

                presets[layerName] = {
                  name: layers[l].Title[0],
                  desc: desc,
                  image: `${url}?SERVICE=WMS&REQUEST=GetMap&SHOWLOGO=false&LAYERS=${layerName}&BBOX=12697069,2555251,12708076,2563048&MAXCC=20&WIDTH=80&HEIGHT=80&gain=1&FORMAT=image/jpeg&bgcolor=00000000&transparent=1&TIME=${moment(
                    maxDate
                  )
                    .subtract(1, 'years')
                    .format(dateFormat)}/${moment(maxDate).format(dateFormat)}`
                }
                if (legendUrl) {
                  presets[layerName].legendUrl = legendUrl
                }
              } else {
                //fill bands
                let desc = layers[l].Abstract !== undefined ? layers[l].Abstract[0] : ''
                let detailDesc = desc.indexOf('|') !== -1 ? layers[l].Abstract[0].split('|')[0] : desc
                let color = desc.indexOf('|') !== -1 ? layers[l].Abstract[0].split('|')[1] : 'red'
                channels.push({
                  name: layerName,
                  desc: detailDesc,
                  color: color
                })
              }
            }
          }
          dsCache[datasetId] = { channels, presets, preset }
          Store.setChannels(channels)
          Store.setPresets(presets)
          if (ds.private) {
              ds.name = instanceName
              Store.current.datasources.push(ds)
          }
          if ((ds !== null || Store.current.preset === null) && !firstLoad) {
            Store.setPreset(preset)
            ds && Store.setDatasource(ds)
          }
          if (!window.location.href.includes('preset') && Store.current.preset === null) {
            Store.setPreset(preset)
          }
          resolve()
        })
      })
      .catch(e => reject(e))
  })
}

function getLegendUrl(layer) {
  let urlCandidate

  try {
    layer.Style.forEach(value => {
      if (value.Name[0] === 'COLOR_MAP') {
        urlCandidate = value.LegendURL[0].OnlineResource[0].$['xlink:href']
      }
    })
  } catch (ex) {}

  return urlCandidate
}

// cache stuff
const cache = {}
window.cache = cache

export function getPrevNextByPoint(dates, timePoint, dateFormat) {
  let unixDates = dates.map(value => moment(value, dateFormat).unix() * 1000)
  let time = moment(timePoint, dateFormat).unix() * 1000

  let prev = null
  let prevs = unixDates.filter(value => value < time).sort((a, b) => b - a)
  prevs.length > 0 ? (prev = moment(prevs[0]).format(dateFormat)) : ''
  let next = null
  let nexts = unixDates.filter(value => value > time).sort((a, b) => a - b)
  nexts.length > 0 ? (next = moment(nexts[0]).format(dateFormat)) : ''
  return { prev, next }
}



// WEBPACK FOOTER //
// ./src/utils/ajax.js